export default {
  department: {
    id: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  departments: [],
  processing: false,
  error: null,
  success: null,
}



